export default __webpack_public_path__ + "../img/f214861e281b52924418597dded97a50.svg";